import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import MetroIcon from '../../assets/metro.svg';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function Metro({ subway }) {
  return subway && subway.name ?
      <div className={cx('ya-map__metro')}>
        <MetroIcon className={cx('ya-map__metroIcon')} fill={subway.color} />
        {subway.name}
      </div>
    : null;
}

Metro.propTypes = {
  subway: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
  }),
};
